import { UserService } from 'src/services/user.service';
import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';
import {TitleService} from 'src/services/title.service';
import {AppNav} from 'src/routes/app-nav';
import {AppSettingsService} from 'src/services/appsettings.service';
import {Subject} from 'rxjs';
import { AuthService } from '@/services/auth.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'login-page',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './login-page.component.html'
})
export class LoginPageComponent implements OnInit, OnDestroy {
  appVersion: string | undefined;
  isIframe: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  readonly LoggedInUser = this.userService.getLoggedInUser();

  constructor(
    private authService: AuthService,
    private titleService: TitleService,
    private appSettingsService: AppSettingsService,
    private router: Router,
    private userService: UserService,
  ) { }

  async ngOnInit() {
    if (await firstValueFrom(this.LoggedInUser)) {
      this.router.navigate(['/']);
      return;
    }

    this.titleService.setTitle(AppNav.Login.title);
    await this.appSettingsService.load();
    this.appVersion = `v${this.appSettingsService.settings.version}`;
  }

  async onLoginButtonClick(): Promise<void> {
      await this.authService.login();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
